import ArchiveInstance from './ArchiveInstance.component';

export default ArchiveInstance;